export const SET_SESSION_ID = 'SET_SESSION_ID'

export const setSessionId = (value: string) => ({ type: SET_SESSION_ID, value })
